<template>
  <div>
    <h1 class="headline">
      {{ headerText }}
      <br />
      <i>{{ seatsAvailableText }}</i>
    </h1>
    <span class="subheading-ranking" v-if="hasElectionRanking && hasCandidates">
      Please rank as many candidates as you wish for the available position(s)
      <br />
      <br />
    </span>

    <div v-if="hasCandidates">
      <p v-html="snippetText"></p>
      <p v-show="resumeDownloadLink">
        <a target="_blank" :href="resumeDownloadLink">
          <span v-if="downloadLinkText">{{ downloadLinkText }}</span>
          <span v-else>Click here for candidate resumes</span>
        </a>
      </p>
      <p v-html="instructionsTextAbstain"></p>
      <p v-html="instructionsTextDefer"></p>
    </div>

    <div v-else>
      <p v-html="snippetTextNoCandidates"></p>
      <p>{{ instructionsText }}</p>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    icon: {
      type: String,
      default: 'group'
    },
    header: {
      type: String
    },
    snippet: {
      type: String
    },
    resumeDownloadLink: {
      type: String
    },
    customOptions: {
      type: Object
    },
    numPositions: {
      type: Number,
      required: true
    },
    hasCandidates: {
      type: Boolean,
      required: true
    },
    preventProxyDeferrals: {
      type: Boolean,
      default: true
    },
    hasElectionRanking: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    }
  },
  computed: {
    seatsAvailableText() {
      return this.shouldHideNumSeatsText
        ? ''
        : `[${this.numPositions} seat(s) available]`;
    },
    headerText() {
      return this.header
        ? this.header
        : 'Whom do you elect to director position(s) on the board?';
    },
    snippetText() {
      if (this.type !== 'simple-vote')
        return this.snippet
          ? this.snippet
          : 'The individuals below have notified us of their intent to be candidates for this position.';
      else {
        return this.snippet;
      }
    },
    snippetTextNoCandidates() {
      return this.snippet
        ? this.snippet
        : `No candidates have come forward for this position, you may nominate up to ${this.numPositions} of your own choosing.`;
    },
    instructionsTextAbstain() {
      const customInstructionsTextAbstain = _.get(
        this.customOptions,
        'instructionsText',
        null
      );
      return customInstructionsTextAbstain
        ? customInstructionsTextAbstain
        : '<i>[ ABSTAIN FROM VOTING ]</i>&emsp;Please leave your votes unused and click "Next Step".';
    },
    instructionsTextDefer() {
      let customInstructionsTextDefer = '';
      if (!this.hasCandidates || !this.preventProxyDeferrals) {
        customInstructionsTextDefer =
          '<i>[ ALLOW MY PROXY TO CHOOSE ]</i>&emsp;Please leave your votes unused and click "Next Step".';
      }
      return customInstructionsTextDefer;
    },
    shouldHideNumSeatsText() {
      return _.has(this.customOptions, 'hideSeatsText')
        ? this.customOptions.hideSeatsText
        : false;
    },
    downloadLinkText() {
      return _.get(this.customOptions, 'downloadLinkText', null);
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.subheading-ranking {
  font-size: 18px !important;
  color: grey;
}
</style>
